import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { CATEGORIES } from "../data/site";

const easeOut = [0.16, 1, 0.3, 1];

export default function Categories() {
  return (
    <section id="collection" className="scroll-mt-24 py-20 md:py-24" data-testid="collection-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, ease: easeOut }}
          >
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-blush-700">
              Shop Our Collection
            </p>
            <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl">
              Eight ways to shine
            </h2>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, ease: easeOut, delay: 0.1 }}
          >
            <Link
              to="/shop"
              data-testid="browse-everything-link"
              className="group inline-flex items-center gap-2 font-display text-base font-semibold text-ink transition-colors duration-200 hover:text-blush-700"
            >
              Browse everything
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </motion.div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-5 lg:grid-cols-4">
          {CATEGORIES.map((c, i) => (
            <motion.div
              key={c.id}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.55, ease: easeOut, delay: (i % 4) * 0.07 }}
            >
              <Link
                to={`/shop?cat=${c.id}`}
                data-testid={`category-card-${c.id}`}
                className={`group flex h-full flex-col items-center overflow-hidden rounded-[32px] ${c.tint} p-6 text-center transition-shadow duration-300 hover:shadow-xl hover:shadow-lav-100`}
              >
                <div className="h-40 w-32 overflow-hidden rounded-t-[80px] rounded-b-2xl border-4 border-white shadow-md">
                  <img
                    src={c.image}
                    alt={c.name}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <h3 className="mt-5 font-display text-lg font-semibold leading-snug text-ink">
                  {c.name}
                </h3>
                <p className="mt-1 text-sm text-muted">{c.tagline}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.2em] text-blush-700">
                  Shop
                  <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
